"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerLink = exports.AI2Banner = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AI2Logo_1 = require("../logos/AI2Logo");
var Layout_1 = require("../Layout");
exports.AI2Banner = React.forwardRef(function (_a, ref) {
    var children = _a.children;
    return (React.createElement(DarkBanner, { ref: ref },
        React.createElement(BannerContent, null, children || (React.createElement(exports.BannerLink, { href: "https://allenai.org" },
            React.createElement(AI2Logo_1.AI2Logo, { color: "white", size: "micro" }))))));
});
exports.BannerLink = styled_components_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-block;\n    padding: 5px 0 2px 0;\n"], ["\n    display: inline-block;\n    padding: 5px 0 2px 0;\n"])));
var BannerContent = (0, styled_components_1.default)(Layout_1.Content)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-top: 0;\n    padding-bottom: 0;\n"], ["\n    padding-top: 0;\n    padding-bottom: 0;\n"])));
var DarkBanner = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background: ", ";\n    padding: ", ";\n    line-height: 1;\n"], ["\n    background: ", ";\n    padding: ", ";\n    line-height: 1;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.background.dark.toString();
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxs + " 0";
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=AI2Banner.js.map